import { Flex } from "@chakra-ui/react";
import { media } from "@utils/media";
import { rem } from "polished";
import { FC } from "react";
import ContentLoader from "react-content-loader";
import { useColors } from "hooks/useColors";

const TitleLoader: FC = () => {
  const { getColor } = useColors();
  return (
    <Flex
      sx={{
        flexDirection: "row",
        gap: 10,
        [media.large]: {
          flexDirection: "column",
          gap: 0,
        },
      }}
    >
      <Flex
        sx={{
          width: "100%",
        }}
      >
        <ContentLoader
          speed={2}
          width="100%"
          backgroundColor={getColor("loader-background-color")}
          foregroundColor={getColor("loader-foreground-color")}
          viewBox="0 0 400 90"
        >
          <rect x="0" y="0" rx="0" ry="5" width="100%" height="50%" />
          <rect x="0" y="55" rx="0" ry="5" width="100%" height="20%" />
        </ContentLoader>
      </Flex>
      <Flex
        sx={{
          width: "100%",
          padding: rem(16),
          border: `1px solid ${getColor("loader-foreground-color")}`,
        }}
      >
        <ContentLoader
          speed={2}
          width="100%"
          backgroundColor={getColor("loader-background-color")}
          foregroundColor={getColor("loader-foreground-color")}
          viewBox="0 0 400 60"
        >
          <rect x="0" y="0" rx="0" ry="5" width="100%" height="60%" />
          <rect x="0" y="75%" rx="0" ry="5" width="100%" height="30%" />
        </ContentLoader>
      </Flex>
    </Flex>
  );
};

export default TitleLoader;
